import { Application } from "@hotwired/stimulus";

window.Stimulus = Application.start();

// bootstrap js controllers
import BsPopoverController from "./bootstrap/bs_popover_controller.js";
Stimulus.register("bs-popover", BsPopoverController);

import BsTooltipController from "./bootstrap/bs_tooltip_controller.js";
Stimulus.register("bs-tooltip", BsTooltipController);

import BsDropdownController from "./bootstrap/bs_dropdown_controller.js";
Stimulus.register("bs-dropdown", BsDropdownController);

// React js controller
import ReactMountController from "./react_mount/index.js";
Stimulus.register("react-mount", ReactMountController);

import ReadMore from '@stimulus-components/read-more'
Stimulus.register('read-more', ReadMore)

import AceEditorController from "./ace_editor_controller";
Stimulus.register("ace-editor", AceEditorController);

import CatalogFieldFillController from "./catalog_field_fill_controller.js";
Stimulus.register("catalog-field-fill", CatalogFieldFillController);

import AddPoNumberController from './add_po_number_controller.js'
Stimulus.register('add-po-number', AddPoNumberController);

import CheckAllController from "./check_all_controller.js";
Stimulus.register("check-all", CheckAllController);

import FeaturesFormController from "./features_form_controller.js";
Stimulus.register("features-form", FeaturesFormController);

import CarouselController from "./carousel";
Stimulus.register("carousel", CarouselController);

import AccordionController from "./accordion";
Stimulus.register("accordion", AccordionController);

import CheckboxReporterController from "./checkbox_reporter";
Stimulus.register("checkbox-reporter", CheckboxReporterController);
import CountryGroupController from "./country_group_controller";
Stimulus.register("country-group", CountryGroupController);

import SelectReporterController from "./select_reporter";
Stimulus.register("select-reporter", SelectReporterController);

import TypeaheadFilterController from "./typeahead_filter";
Stimulus.register("typeahead-filter", TypeaheadFilterController);

import RemoteFormController from "./remote_form";
Stimulus.register("remote-form", RemoteFormController);

import LocalTimeController from "./local_time_controller.js";
Stimulus.register("local-time", LocalTimeController);

import ImagePreviewController from "./image_preview_controller.js";
Stimulus.register("image-preview", ImagePreviewController);

import FilterableFormController from "./filterable_form";
Stimulus.register("filterable-form", FilterableFormController);

import RfxResponseController from "./rfx_response_controller";
Stimulus.register("rfx-response", RfxResponseController);

import ResetFiltersController from "./reset_filters";
Stimulus.register("reset-filters", ResetFiltersController);

import InfiniteScrollController from "./infinite_scroll";
Stimulus.register("infinite-scroll", InfiniteScrollController);

import RenameEventController from "./rename_event";
Stimulus.register("rename-event", RenameEventController);

import ToggleController from "./toggle";
Stimulus.register("toggle", ToggleController);

import ToggleClassController from "./toggle_class_controller.js";
Stimulus.register("toggle-class", ToggleClassController);

import MilestoneGroupToggleController from "./milestone_group_toggle_controller.js";
Stimulus.register("milestone-group-toggle", MilestoneGroupToggleController);

import RfxNotesController from "./rfx_notes_controller.js";
Stimulus.register("rfx-notes", RfxNotesController);

import RfxNoteAudienceController from "./rfx_note_audience_controller.js";
Stimulus.register("rfx-note-audience", RfxNoteAudienceController);

import BackToTopController from "./back_to_top";
Stimulus.register("back-to-top", BackToTopController);

import ScrollTopToggleController from "./scroll_top_toggle_controller";
Stimulus.register("scroll-top-toggle", ScrollTopToggleController);

import TypeaheadController from "./typeahead";
Stimulus.register("typeahead", TypeaheadController);

import InventoryTypeaheadController from "./inventory/typeahead_controller";
Stimulus.register("inventory-typeahead", InventoryTypeaheadController);

import LibraryMappingReloadController from "./library_mapping_reload_controller";
Stimulus.register("library-mapping-reload", LibraryMappingReloadController);

import DisableButtonController from "./disable_button";
Stimulus.register("disable-button", DisableButtonController);

import CasNumberFilterController from "./cas_number_filter";
Stimulus.register("cas-number-filter", CasNumberFilterController);

import HelloController from "./hello";
Stimulus.register("hello", HelloController);

import StructureSearchController from "./structure_search";
Stimulus.register("structure-search", StructureSearchController);

import SupersetEmbedReportController from "./superset_embed_report";
Stimulus.register("superset-embed-report", SupersetEmbedReportController);

import CertificationFileUploadController from "./certification_file_upload_controller";
Stimulus.register("certification-file-upload", CertificationFileUploadController);

import SelectAndRedirectController from "./select_and_redirect";
Stimulus.register("select-and-redirect", SelectAndRedirectController);

import RemoveController from "./remove";
Stimulus.register("remove", RemoveController);

import SelectTwoController from "./select_two";
Stimulus.register("select-two", SelectTwoController);

import TemporaryController from "./temporary";
Stimulus.register("temporary", TemporaryController);

import FocusController from "./focus_controller.js";
Stimulus.register("focus", FocusController);

import WatcherController from "./watcher";
Stimulus.register("watcher", WatcherController);

import ProposalDismissNegotiationController from "./proposal_dismiss_negotiation.js";
Stimulus.register("proposal-dismiss-negotiation", ProposalDismissNegotiationController);

import ResponsiveSelectController from "./responsive_select_controller";
Stimulus.register("responsive-select", ResponsiveSelectController);

import FavoritesController from './favorites.js'
Stimulus.register('favorites', FavoritesController);
import CartQuantityController from './cart_quantity_controller.js';
Stimulus.register('cart-quantity', CartQuantityController);

import SearchOverviewController from './search_overview.js'
Stimulus.register('search-overview', SearchOverviewController);

import JqueryEvent from './jquery_event'
Stimulus.register('jquery-event', JqueryEvent);

import QuantityGridController from './quantity_grid.js'
Stimulus.register('quantity-grid', QuantityGridController);

import AdvancedFiltersToggleController from './advanced_filters_toggle.js'
Stimulus.register('advanced-filters-toggle', AdvancedFiltersToggleController);

import ToggleCollapseText from './toggle_collapse_text.js'
Stimulus.register('toggle-collapse-text', ToggleCollapseText);

import TruncatedTextToggleController from './truncated_text_toggle_controller.js'
Stimulus.register('truncated-text-toggle', TruncatedTextToggleController);

import MatchHeights from './match_heights.js'
Stimulus.register('match-heights', MatchHeights);

import SiteVisitSelectController from "./site_visit_select.js"
Stimulus.register('site-visit-select', SiteVisitSelectController)

import HtmxModalController from './htmx_modal'
Stimulus.register('htmx-modal', HtmxModalController)

import GridPanelController from './grid_panel_controller'
Stimulus.register('grid-panel', GridPanelController)

import DatePickerController from './date_picker'
Stimulus.register('date-picker', DatePickerController)

import DynamicFormChemdoodleController from './dynamic_form_chemdoodle.js'
Stimulus.register('dynamic-form-chemdoodle', DynamicFormChemdoodleController)

import ChemimagerController from './chemimager.js'
Stimulus.register('chemimager', ChemimagerController)

import SliSearchFilterController from './saved_line_items/search_filter.js'
Stimulus.register('sli-search-filter', SliSearchFilterController)

import SiteScheduleFilterController from './trials/site_schedule_filter.js'
Stimulus.register('site-schedule-filter', SiteScheduleFilterController)

import PassAlongCountryController from './trials/pass_along_country.js'
Stimulus.register('pass-along-country', PassAlongCountryController)

import TrialsRemoveItemFormController from './trials/remove_item_form.js'
Stimulus.register('remove-item-form', TrialsRemoveItemFormController)

import UnifiedSearchFormController from './unified_search_form.js'
Stimulus.register('unified-search-form', UnifiedSearchFormController)

import SearchesFilterableFormController from './searches_filterable_form.js'
Stimulus.register('searches-filterable-form', SearchesFilterableFormController)

import MessageFormController from './message_form_controller.js'
Stimulus.register('message-form', MessageFormController)

// proposal form controllers
import TransactionFeeController from './proposals/transaction_fee_controller.js'
Stimulus.register('transaction-fee', TransactionFeeController)

import ProposalLineItemContainerController from './proposals/line_item_container_controller.js'
Stimulus.register('proposal-line-item-container', ProposalLineItemContainerController);

import ProposalLineItemController from './proposals/line_item_controller.js'
Stimulus.register('proposal-li', ProposalLineItemController);

import ProposalShippingContactController from './proposals/shipping_contact_controller.js'
Stimulus.register('proposal-shipping-contact', ProposalShippingContactController);

import ChartJsController from './chart_js_controller.js'
Stimulus.register('chart-js', ChartJsController);

import RevealBiEmbedController from './reveal_bi_embed_controller.js'
Stimulus.register('reveal-bi-embed', RevealBiEmbedController);

import RevealSavedViewsController from './reveal_saved_views_controller.js'
Stimulus.register('reveal-saved-views', RevealSavedViewsController);

import RevealBiNewController from './reveal_bi_new_controller.js'
Stimulus.register('reveal-bi-new', RevealBiNewController);

import RevealAiChatController from './reveal_ai_chat_controller.js'
Stimulus.register('reveal-ai-chat', RevealAiChatController);

import RevealBiPublishController from './reveal_bi_publish_controller.js'
Stimulus.register('reveal-bi-publish', RevealBiPublishController);


import RevealEmbedViewModeController from './reveal_embed_view_mode_controller.js'
Stimulus.register('reveal-embed-view-mode', RevealEmbedViewModeController);

import RevealListMemoryController from './reveal_list_memory_controller.js'
Stimulus.register('reveal-list-memory', RevealListMemoryController);


import DisableInputsController from './disable_inputs_controller.js'
Stimulus.register('disable-inputs', DisableInputsController);

import SortableController from './sortable_controller.js'
Stimulus.register('sortable', SortableController);

import ServiceSortableController from './service_sortable_controller.js'
Stimulus.register('service-sortable', ServiceSortableController);

import PagepusherModalController from './pagepusher_modal_controller.js'
Stimulus.register('pagepusher-modal', PagepusherModalController);

import OrgIdsJsonController from './org_ids_json_controller.js'
Stimulus.register('org-ids-json', OrgIdsJsonController);

import CopyUrlController from './copy_url_controller.js'
Stimulus.register('copy-url', CopyUrlController);

// configuration rules form controllers
import CriteriaGroupsController from './configuration_rules/criteria_groups_controller.js'
Stimulus.register('criteria-groups', CriteriaGroupsController);

import DirectivesController from './configuration_rules/directives_controller.js'
Stimulus.register('directives', DirectivesController);

import SaveSearchController from './configuration_rules/save_search_controller.js'
Stimulus.register('save-search', SaveSearchController);

import VisitNameController from "./visit_name_controller.js";
Stimulus.register("visit-name", VisitNameController);

import SavedLineItemsController from './saved_line_items_controller.js';
Stimulus.register('saved-line-items', SavedLineItemsController);

import CarrierSelectorController from './carrier_selector_controller.js';
Stimulus.register('carrier-selector', CarrierSelectorController);

import ShippingDetailsController from './shipping_details_controller.js';
Stimulus.register('shipping-details', ShippingDetailsController);

import ConditionalDisplayController from './conditional_display_controller.js';
Stimulus.register('conditional-display', ConditionalDisplayController);

import CheckboxEnablesController from './checkbox_enables_controller.js';
Stimulus.register('checkbox-enables', CheckboxEnablesController);

import PaymentMirrorController from './payment_mirror_controller.js';
Stimulus.register('payment-mirror', PaymentMirrorController);

import SubmitIndicatorController from './submit_indicator_controller.js';
Stimulus.register('submit-indicator', SubmitIndicatorController);

import BenchmateAutofillController from './benchmate_autofill_controller.js';
Stimulus.register('benchmate-autofill', BenchmateAutofillController);

import RfiDownloadController from './rfi_download_controller.js';
Stimulus.register('rfi-download', RfiDownloadController);

import TicketsController from "./tickets_controller";
Stimulus.register("tickets", TicketsController);

import FolderPickerController from "./folder_picker_controller";
Stimulus.register("folder-picker", FolderPickerController);

import CartImportRowController from './inventory/cart_import_row_controller.js';
Stimulus.register('inventory-cart-import-row', CartImportRowController);

import CartImportConfirmController from './inventory/cart_import_confirm_controller.js';
Stimulus.register('inventory-cart-import-confirm', CartImportConfirmController);

import NavDropdownController from './nav_dropdown_controller.js';
Stimulus.register('nav-dropdown', NavDropdownController);

import NavSpotlightController from './nav_spotlight_controller.js';
Stimulus.register('nav-spotlight', NavSpotlightController);

import NavFilterController from './nav_filter_controller.js';
Stimulus.register('nav-filter', NavFilterController);

import ConfirmDialogController from './confirm_dialog_controller.js';
Stimulus.register('confirm-dialog', ConfirmDialogController);

import PromptDialogController from './prompt_dialog_controller.js';
Stimulus.register('prompt-dialog', PromptDialogController);

import ClipboardController from './clipboard_controller.js';
Stimulus.register('clipboard', ClipboardController);

import SearchSpotlightTriggerController from './search_spotlight_trigger_controller.js';
Stimulus.register('search-spotlight-trigger', SearchSpotlightTriggerController);

import FileSizeLimitController from './file_size_limit_controller.js';
Stimulus.register('file-size-limit', FileSizeLimitController);

import GplCompareLinkController from './gpl_compare_link_controller.js';
Stimulus.register('gpl-compare-link', GplCompareLinkController);

import RunCleanersController from './run_cleaners_controller.js';
Stimulus.register('run-cleaners', RunCleanersController);
